export default "__VITE_ASSET__37fe29e3__"